import { ValueTypeSwitcher } from 'legacy/lut/components/widgets/public/partner360/common/valueTypeSwitcher/ValueTypeSwitcher'
import React, { useCallback } from 'react'

import { ActualsValueTypes } from 'partner360/models/actualValueTypes'

interface IValueTypeButtonsProps {
  valueType?: ActualsValueTypes
  onChangeValueType: (value: ActualsValueTypes) => void
  valueTypes: ActualsValueTypes[]
}

export const EltValueTypeSwitcher = ({
  valueType = ActualsValueTypes.Net,
  onChangeValueType,
  valueTypes,
}: IValueTypeButtonsProps) => {
  const handleChangeValueType = useCallback(
    (valueType: string) => {
      onChangeValueType(valueType as ActualsValueTypes)
    },
    [onChangeValueType]
  )

  return (
    <ValueTypeSwitcher
      valueType={valueType}
      onChangeValueType={handleChangeValueType}
      background={'bg-white'}
      valueTypes={valueTypes}
    />
  )
}
